var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"p-2 relative rounded-lg",class:{ 'bg-primary-300': _vm.isPopupOpen },attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('span',{staticClass:"rounded-full size-2 absolute top-1 right-1",class:{
        'bg-green-500': _vm.isHotlistActive,
        'bg-red-500': !_vm.isHotlistActive,
        'animate-ping': _vm.isLoading,
      }}),_vm._v(" "),_c(_setup.FireSolidIcon,{tag:"component",staticClass:"size-6 fill-gray-100"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }